// extracted by mini-css-extract-plugin
export var warningWrapper = "B_vh g_ch g_dm g_dw g_dq g_b8 g_cM g_dz";
export var btn = "B_bh g_fl g_dK g_gj g_f8";